import React, { useState, useCallback } from "react";
import { getMeasurements } from "../../utilities/string";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import Modal from "../ui/Modal";
import chevronRight from "../../assets/icons/chevron-right.svg";
import chevronLeft from "../../assets/icons/chevron-left.svg";

const Floorplans = ({ floorPlan, cabinLength, headRoom, cabinWidth }) => {
    const [showModal, setShowModal] = useState(false);
    const [initialSlide, setInitialSlide] = useState(0);
    const [swiperRef, setSwiperRef] = useState();
    const [counter, setCounter] = useState(1);

    const prevClickHandler = useCallback(() => {
        if (!swiperRef) return;
        swiperRef.slidePrev();
    }, [swiperRef]);

    const nextClickHandler = useCallback(() => {
        if (!swiperRef) return;
        swiperRef.slideNext();
    }, [swiperRef]);

    if (!floorPlan || floorPlan.length === 0) {
        return null;
    }

    const crossSectionImage = floorPlan.length > 1 ? floorPlan[floorPlan.length - 1] : null;
    const floorPlanImages = floorPlan.length > 1 ? floorPlan.slice(0, -1) : floorPlan;

    const allImages = crossSectionImage ? [...floorPlanImages, crossSectionImage] : floorPlanImages;

    const handleImageClick = (index) => {
        setInitialSlide(index);
        setShowModal(true);
        setCounter(index + 1);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const setCounterHandler = (swiper) => {
        if (swiper) {
            setCounter(swiper.realIndex + 1);
        }
    };

    return (
        <>
            <div className="aircraft-card-extra-content__floor-plans">
                <div className="aircraft-card-extra-content__column__title">FLOORPLANS</div>
                <div className="aircraft-card-extra-content__floor-plans-row">
                    <div className="aircraft-card-extra-content__floor-plans-content">
                        <div className="aircraft-card-extra-content__floor-plans-images">
                            {floorPlanImages.map((plan, index) => (
                                <div key={index} className="aircraft-card-extra-content__floor-plan-item">
                                    <div className="aircraft-card-extra-content__floor-plan-label">
                                        {index === 0 ? "Day" : index === 1 ? "Night" : `Plan ${index + 1}`}
                                    </div>
                                    <img
                                        src={plan.url}
                                        alt={plan.alt || "Floor plan"}
                                        className="aircraft-card-extra-content__floor-plan-image aircraft-card-extra-content__floor-plan-image--clickable"
                                        onClick={() => handleImageClick(index)}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="aircraft-card-extra-content__dimensions">
                        <div className="aircraft-card-extra-content__dimensions-cross-section-wrapper">
                            {crossSectionImage && (
                                <img
                                    src={crossSectionImage.url}
                                    alt={crossSectionImage.alt || "Cross section"}
                                    className="aircraft-card-extra-content__dimensions-cross-section-image aircraft-card-extra-content__floor-plan-image--clickable"
                                    onClick={() => handleImageClick(floorPlanImages.length)}
                                    style={{ cursor: "pointer" }}
                                />
                            )}
                            <div className="aircraft-card-extra-content__dimensions-measurements">
                                {cabinLength && (
                                    <p className="aircraft-card-extra-content__dimension-length">
                                        Length: <strong>{getMeasurements(cabinLength)}</strong>
                                    </p>
                                )}
                                {headRoom && (
                                    <p className="aircraft-card-extra-content__dimension-height">
                                        Height: <strong>{getMeasurements(headRoom)}</strong>
                                    </p>
                                )}
                                {cabinWidth && (
                                    <p className="aircraft-card-extra-content__dimension-width">
                                        Width: <strong>{getMeasurements(cabinWidth)}</strong>
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Floorplan Slideshow Modal */}
            <Modal
                modalVisible={showModal}
                closeModal={closeModal}
                modalClassNames="modal--floorplan-slideshow"
                closeCrossColour="black"
            >
                <div className="floorplan-slideshow">
                    {allImages.length > 1 && (
                        <>
                            <div className="floorplan-slideshow__counter">
                                {counter}/{allImages.length}
                            </div>
                            <button
                                type="button"
                                onClick={prevClickHandler}
                                className="swiper-nav-button floorplan-slideshow__nav-button floorplan-slideshow__nav-button--prev"
                            >
                                Prev
                                <img src={chevronLeft} alt="" />
                            </button>
                            <button
                                type="button"
                                onClick={nextClickHandler}
                                className="swiper-nav-button swiper-nav-button__next floorplan-slideshow__nav-button floorplan-slideshow__nav-button--next"
                            >
                                Next
                                <img src={chevronRight} alt="" />
                            </button>
                        </>
                    )}
                    <Swiper
                        onSwiper={setSwiperRef}
                        onActiveIndexChange={(swiper) => setCounterHandler(swiper)}
                        initialSlide={initialSlide}
                        grabCursor={true}
                        speed={400}
                        loop={allImages.length > 1}
                        modules={[Navigation, A11y]}
                        touchStartPreventDefault={false}
                        className="floorplan-slideshow__swiper"
                        slidesPerView={1}
                    >
                        {allImages.map((image, index) => (
                            <SwiperSlide key={index} className="floorplan-slideshow__slide">
                                <div className="floorplan-slideshow__image-wrapper">
                                    <img
                                        className="floorplan-slideshow__image"
                                        src={image.url}
                                        alt={image.alt || `Floor plan ${index + 1}`}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </Modal>
        </>
    );
};

export default Floorplans;
